module.exports = __webpack_public_path__ + "static/img/defaultProduct.cdeb1367.png";